import React from 'react';

import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql } from 'gatsby';
import { Layout } from '~/components/molecules/Layout';
import { SEO } from '~/components/atoms/SEO';
// eslint-disable-next-line import/no-cycle
import ContactPage from '../ContactPage/ContactPage';
import { TranslationContext } from '~/utils/styles/utils';

const Contact: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <SEO
        title={t('ContactSeoTitle')}
        metaDescription={t('ContactSeoMetaDescription')}
      />
      <TranslationContext.Provider value={t}>
        <ContactPage />
      </TranslationContext.Provider>
    </Layout>
  );
};

export const useTranslationContext = () => React.useContext(TranslationContext);

export default Contact;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(
      filter: { ns: { in: ["homepage"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
